module.exports = __webpack_public_path__ + "img/archiveProduction.2f1a7f66.png";